
import { connect } from 'react-redux';

import { assign as _assign } from 'lodash';

import {
  RegisterUserModel,
  GlobalState,
  formatMessage,
} from 'src/api';

import {
  registerUserFormValues
} from 'src/api/models/Registration/user/user.class';

import {
  createForm, CreateFormProps
} from 'src/api/models/Form/Form'

import { requestAPIActions, RequestApiHttpPayload} from 'loopback-react-request';

import MESSAGES from './RegisterUserForm.messages';
import './RegisterUserForm.scss';

export const RegisterUserFormComponent = createForm<RegisterUserModel, CreateFormProps<RegisterUserModel>>({
  dispatchData: (dispatch, values, state) => {
    delete values.passwordRepeat;

    // Get the language from the state
    const lang = state && state.localize.language.selected;

    // Include the language in the request data
    return dispatch(
      requestAPIActions.load<RequestApiHttpPayload>('registerUser', {
        url: '/Users',
        options: {
          method: 'POST',
          data: {
            ...values,
            userData: { lang },
          },
        },
      })
    );
  },
  formFields: registerUserFormValues(),
  redirectTo: '/register/succeeded',
  stateKeys: 'registerUser',
  shouldRedirect: true,
  submitButton: {
    text: formatMessage({...MESSAGES.registerUserFormButton}),
    className: 'register-button mt-3 w-100'
  }
})();

export const RegisterUserForm = connect((state: GlobalState) => ({
  state,
  selectedLanguage: state.localize.language.selected,
}))(RegisterUserFormComponent);